import React, { useMemo } from "react";
import Receipt, { mapRecordToReceiptData } from "../components/Receipt";

/**
 * Payment receipt for modal / PDF. Maps API `receipt` into `<Receipt />` props.
 */
const ReceiptViewContent = ({ receipt }) => {
  const data = useMemo(() => mapRecordToReceiptData(receipt), [receipt]);

  return <Receipt data={data} />;
};

export default ReceiptViewContent;
